import { Switch, Route } from "react-router"
import { Box,  Center  } from "@chakra-ui/react";

import Nav from "./Nav/Nav"
import Home from "./Home/Home";
import Juegos from "./Juegos/Juegos";
import Proceso from "./Proceso/Proceso";
import Recursos from "./Recursos/Recursos";
import Contactos from "./Contactos/Contactos";
import Footer from "./Footer/Footer";

const Switcher = () => {
	    return <Switch>
			        <Box 	minHeight="100vh"
			            	height="100%"
			            	bg="zpurple.100"
			        >
				            <Box mx={{base: "0%", sm: "5%"}}    >
				                <Nav bg="zpurple.100"/>
				
				                <Center bg="zpurple.600" >
				                    <Route path="/" exact>
				                        <Home/>
				                    </Route>                        
				                    <Route path="/juegos" exact>
				                        <Juegos/>
				                    </Route>
				                    <Route path="/proceso" exact>
				                        <Proceso/>
				                    </Route>
				                    <Route path="/recursos" exact>
				                        <Recursos/>
				                    </Route>                    
				                    <Route path="/Contactos" exact>
				                        <Contactos/>
				                    </Route>
				                </Center>        
				            
				                <Footer/>
				
				            </Box>
	       			 </Box>
	    		</Switch>
}

export default Switcher